import React, {useEffect, useState} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {CModal, CModalHeader} from '@coreui/react'
import './scss/style.scss'
import './scss/_custom.scss'
import PrivateRoute from './routes/PrivateRoute'
import PrivateMemberRoute from './routes/PrivateMemberRoute'
import {history} from './redux/store'
import {ConnectedRouter} from 'connected-react-router'
import {useSelector, useDispatch} from 'react-redux'
import LoadingScreen from './views/LoadingScreen'
import {setPopupMessage} from './redux/actions/app'
import {needsNameUpdate} from './helpers'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const MessagePopup = ({show, onClosed, message}) => {
  return (
    <CModal closeOnBackdrop centered show={show} onClosed={onClosed}>
      <CModalHeader closeButton className="border-0">
        {message}
      </CModalHeader>
    </CModal>
  )
}

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Legals = React.lazy(() => import('./views/pages/legals/Legals'))
const Profile = React.lazy(() => import('./views/pages/profile/Profile'))
const UpdateProfile = React.lazy(() => import('./views/pages/updateProfile/UpdateProfile'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const App = () => {
  const [visible, setVisible] = useState(false)
  const showGlobalIndicator = useSelector((state) => state.app.showGlobalIndicator)
  const popupMessage = useSelector((state) => state.app.popupMessage)
  const memberInfo = useSelector((state) => state.member.memberInfo)
  const dispatch = useDispatch()

  const mustCompleteProfile = needsNameUpdate(memberInfo)

  useEffect(() => {
    if (popupMessage !== '' && popupMessage !== undefined) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }, [popupMessage])

  return (
    <React.Suspense fallback={loading}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route exact path="/login" name="Login Page" render={(props) => <Login {...props} />} />
          <Route exact path="/legals" name="Legals Page" render={(props) => <Legals {...props} />} />
          <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
          <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
          <PrivateMemberRoute path={'/update-profile'}>
            <Route
              path="/update-profile"
              name="Update Profile"
              render={(props) =>
                mustCompleteProfile ? <UpdateProfile {...props} /> : <Redirect to="/profile" />
              }
            />
          </PrivateMemberRoute>
          <PrivateMemberRoute path={'/profile'}>
            <Route
              path="/profile"
              name="Profile"
              render={(props) =>
                mustCompleteProfile ? <Redirect to="/update-profile" /> : <Profile {...props} />
              }
            />
          </PrivateMemberRoute>
          <PrivateRoute path={'/'}>
            <Route path="/" name="Home" render={(props) => <TheLayout {...props} />} />
          </PrivateRoute>
        </Switch>
      </ConnectedRouter>
      <MessagePopup
        show={visible}
        message={popupMessage}
        onClosed={() => {
          dispatch(setPopupMessage(''))
          setVisible(false)
        }}
      />
      {showGlobalIndicator && <LoadingScreen />}
    </React.Suspense>
  )
}

export default App
